module.exports = __webpack_public_path__ + "static/media/transaction-history-business-hover.02208d18.svg";